import {
  alpha,
  Box,
  ButtonBase,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const REGULAR_BOOKING_OPTIONS = [
  {
    value: "indefinite",
    title: "Bis auf Weiteres",
    description:
      "Der Slot bleibt regelmäßig bei dir, bis du ihn aktiv änderst.",
  },
  {
    value: "month_end",
    title: "Bis Monatsende",
    description:
      "Die regelmäßige Buchung endet automatisch am letzten Tag dieses Monats.",
  },
  {
    value: "months",
    title: "Für mehrere Monate",
    description:
      "Du legst fest, für wie viele Kalendermonate die Serie gelten soll.",
  },
];

export default function TrainerRegularBookingConfigurator({
  regularBookingConfig,
  regularBookingPreview,
  onChangeDuration,
  onChangeMonths,
}) {
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 2.5,
        borderColor: alpha(theme.palette.primary.main, 0.24),
        background: `linear-gradient(160deg, ${alpha(
          theme.palette.primary.main,
          0.06,
        )}, ${alpha(theme.palette.background.paper, 0.98)})`,
      }}
    >
      <Stack spacing={1.25}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
            Wie lange soll die regelmäßige Buchung gelten?
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Die Serie startet immer mit dem ausgewählten Termin.
          </Typography>
        </Box>

        <Stack spacing={0.75}>
          {REGULAR_BOOKING_OPTIONS.map((option) => {
            const isSelected = regularBookingConfig.durationType === option.value;

            return (
              <ButtonBase
                key={option.value}
                onClick={() => onChangeDuration(option.value)}
                sx={{
                  width: "100%",
                  textAlign: "left",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: isSelected
                    ? "primary.main"
                    : alpha(theme.palette.divider, 0.85),
                  backgroundColor: isSelected
                    ? alpha(theme.palette.primary.main, 0.08)
                    : alpha(theme.palette.background.default, 0.3),
                  px: 1.2,
                  py: 1,
                }}
              >
                <Stack spacing={0.2} sx={{ width: "100%" }}>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {option.title}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {option.description}
                  </Typography>
                </Stack>
              </ButtonBase>
            );
          })}
        </Stack>

        {regularBookingConfig.durationType === "months" && (
          <FormControl size="small" fullWidth>
            <InputLabel id="regular-booking-months-label">Monate</InputLabel>
            <Select
              labelId="regular-booking-months-label"
              value={regularBookingConfig.months}
              label="Monate"
              onChange={(event) => onChangeMonths(event.target.value)}
            >
              {Array.from({ length: 12 }, (_, index) => index + 1).map(
                (monthCount) => (
                  <MenuItem key={monthCount} value={monthCount}>
                    {monthCount} Monat{monthCount === 1 ? "" : "e"}
                  </MenuItem>
                ),
              )}
            </Select>
          </FormControl>
        )}

        <Paper
          variant="outlined"
          sx={{
            p: 1.1,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.background.paper, 0.82),
          }}
        >
          <Stack spacing={0.35}>
            <Typography variant="caption" color="text.secondary">
              Zeitraum
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {regularBookingPreview.rangeLabel}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {regularBookingPreview.helperLabel}
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </Paper>
  );
}
